import axios from 'axios'

import { PowerReviews } from '@thg-commerce/enterprise-aurora-product/resolvers/ProductPage/types'
import { GraphQLContext } from '@thg-commerce/enterprise-core/src/graphql/types'

export const getPowerReviewSchema = async (args: {
  config?: GraphQLContext['config']
  externalIdentifier: string | undefined
  sku?: string | undefined
}): Promise<PowerReviews | null> => {
  if (!args.config || !args.externalIdentifier || !args.sku) {
    return null
  }

  const {
    powerReviewMerchantId = undefined,
    powerReviewApiKey = undefined,
    showPowerReview = undefined,
    powerReviewSingleProductApiUrl = undefined,
    powerReviewSingleProductApiTimeout = undefined,
    enableSkuOnPowerReviews = false,
  } = args.config?.siteConfig

  const { defaultLocale: locale } = args.config.siteDefinition

  if (
    showPowerReview &&
    args.externalIdentifier &&
    powerReviewSingleProductApiUrl
  ) {
    try {
      const { data: powerReviewData } = await axios({
        url: `${powerReviewSingleProductApiUrl}/m/${powerReviewMerchantId}/l/${locale}/product/${
          enableSkuOnPowerReviews ? args.sku : args.externalIdentifier
        }/reviews?apikey=${powerReviewApiKey}&_noconfig=true`,
        timeout: powerReviewSingleProductApiTimeout || 150,
      })

      if (powerReviewData?.results.length > 0) {
        return {
          ratingValue:
            powerReviewData.results[0]?.rollup?.average_rating ?? null,
          reviewCount: powerReviewData.results[0]?.rollup?.review_count ?? null,
          reviews: powerReviewData.results[0]?.reviews.map((review) => {
            return {
              schemaType: 'Review',
              name: review.details.headline,
              description: review.details.comments,
              datePublished: new Date(review.details.created_date)
                .toISOString()
                .split('T')[0],
              author: {
                schemaType: 'Person',
                name: review.details.nickname,
              },
              reviewRating: {
                schemaType: 'Rating',
                ratingValue: review.metrics.rating,
              },
            }
          }),
        }
      }
    } catch (e) {
      console.error('Failed to fetch power reviews with error', e.message)
      return null
    }
  }

  return null
}
